const UploadImageButton = (props) => {
    return (
        <div className="upload-image-button flex-centered" onClick={() => props.onClick()}>
            <i className="las la-camera"></i>
        </div>
    )
}

export default UploadImageButton